export namespace SORT_BY_FIELD {
    export const IDENTIFIER = "identifierInteger"
}


// WEBPACK FOOTER //
// ./src/utils/search/constants.ts